import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import P from '@leverege/promise';
import { Plugins, Context } from '@leverege/plugin';
import Relationship from "../Relationship.js"; // import LoadingView from '../../views/LoadingView'
const EMPTY = {};
class Transaction {
  constructor(objRef, cxt) {
    this.objRef = objRef;
    this.data = {};
    this.relationship = [];
    this.resourceImage = [];
    this.hasData = false;
    this.hasRelationship = false;
    this.hasResourceImage = false;
    this.context = cxt;
  }
  addPath(part, path, value) {
    this.hasData = true;
    if (this.data[part] == null) {
      if (part !== 'header') {
        this.data[part] = [];
      }
    }
    if (part === 'header') {
      this.data[path] = value;
    } else {
      const existingIndex = this.data[part].findIndex(val => val.path === path);
      if (existingIndex === -1) {
        this.data[part].push({
          path,
          value,
          op: 'replace'
        });
      } else {
        this.data[part][existingIndex] = {
          path,
          value,
          op: 'replace'
        };
      }
    }
  }
  setRelationship(parentRef, childRef, parentPath) {
    this.hasRelationship = true;
    this.relationship.push({
      parentRef,
      childRef,
      parentPath,
      op: 'set'
    });
  }
  addRelationship(parentRef, childRef, parentPath) {
    this.hasRelationship = true;
    this.relationship.push({
      parentRef,
      childRef,
      parentPath,
      op: 'add'
    });
  }
  removeRelationship(parentRef, childRef, parentPath, parentKey) {
    this.hasRelationship = true;
    this.relationship.push({
      parentRef,
      childRef,
      parentPath,
      parentKey,
      op: 'remove'
    });
  }
  setResourceImage(objRef, value, path, imagePath, valueOverwrite) {
    this.hasResourceImage = true;
    const existingIndex = this.resourceImage.findIndex(val => {
      return val.objRef?.id === objRef?.id && val.objRef?.path === objRef?.path && val.path === path;
    });
    if (existingIndex === -1) {
      this.resourceImage.push({
        objRef,
        value,
        path,
        op: 'set',
        imagePath,
        valueOverwrite
      });
    } else {
      this.resourceImage[existingIndex] = {
        objRef,
        value,
        path,
        op: 'set',
        imagePath,
        valueOverwrite
      };
    }
  }
  removeResourceImage(objRef, path, imagePath) {
    this.hasResourceImage = true;
    this.resourceImage.push({
      objRef,
      path,
      op: 'remove',
      imagePath
    });
  }
  setRelationshipOp(parentRef, childRef, parentPath) {
    // Fetch parent.
    // If parent has child, promisify confirmation dialog.
    //   If confirmed:
    //     Add request with force : true.
    //       Fetch previous child to recalc redux.
    // Else:
    //   Add request w/o force : true.

    const pActions = DataSources.getActions(parentRef);
    const cActions = pActions.child(parentPath);

    // const lookup = GlobalState.get().models.lookup

    // const parentObjectTypeName = cActions.relationship.parent.objectTypeName
    // const parentName = lookup?.[parentRef.id]?.name
    // const childObjectTypeName = cActions.relationship.objectTypeName
    // const childName = lookup?.[childRef.id]?.name

    // Get parent through a request and not through state to avoid stale values.
    return GlobalState.dispatch(pActions.child(parentPath).get()).then(async prevChild => {
      // If parent already has a child, promisify creation dialog to confirm the operation (overwriting current relationship).
      if (prevChild) {
        // const childName = lookup?.[prevChild.id]?.name
        // const title = t( 'childPairedTitle', { parentObjectTypeName, childObjectTypeName } ) 
        // const message = t( 'childPairedMessage', { parentObjectTypeName, parentName, childObjectTypeName, childName } )
        // TODO: This is no good. Shouldn't mix UI code with Setters
        const confirmed = true; // await Dialog.Question.ask( { title, message } )

        if (confirmed) {
          // User confirmed operation, force relationship creation. Refresh previous child after.
          return GlobalState.dispatch(cActions.create({
            id: childRef.id,
            force: true
          }));
        }

        // User didn't confirm, noop.
        return null;
      }

      // Creation still needs to be forced in order to delete a possible current relationship w/ another parent.
      // Still, we don't need to confirm the operation, given that the current parent name is visible in the selector.
      return GlobalState.dispatch(cActions.create({
        id: childRef.id
      })).catch(async err => {
        if (err.status === 400) {
          // const title = t( 'parentPairedTitle', { parentObjectTypeName, childObjectTypeName } ) 
          // const message = t( 'parentPairedMessage', { parentObjectTypeName, parentName, childObjectTypeName, childName } )
          const confirmed = true; // await Dialog.Question.ask( { title, message } )

          if (confirmed) {
            const res = await GlobalState.dispatch(cActions.create({
              id: childRef.id,
              force: true
            }));
            return res;
          }
        }
        throw err;
      });
    });
  }
  createOrUpdateData({
    delegate,
    promises
  }) {
    if (delegate) {
      const hookPlgs = Plugins.get('ItemCreateHook', m => {
        return Context.isMatch({
          objectType: delegate.relationship.objectType,
          path: delegate.relationship.path
        }, m);
      });
      if (hookPlgs.length > 0) {
        promises.push(GlobalState.dispatch(async (dispatch, getState) => {
          let data = this.data;
          for (let i = 0; i < hookPlgs.length; i++) {
            const plg = hookPlgs[i];
            // eslint-disable-next-line no-await-in-loop
            data = await plg.hook(data, this.context?.clientProps);
          }
          return dispatch(delegate.update(data));
        }));
      } else {
        promises.push(GlobalState.dispatch(delegate.update(this.data)));
      }
    } else {
      const err = new Error('Actions are not found for object');
      err.objRef = this.objRef;
      promises.push(Promise.reject(err));
    }
  }
  createOrUpdateRelationships({
    promises,
    after
  }) {
    for (let n = 0; n < this.relationship.length; n++) {
      const {
        parentRef,
        childRef,
        parentPath,
        parentKey,
        op
      } = this.relationship[n];
      const pActions = DataSources.getActions(parentRef);
      const cActions = pActions.child(parentPath);
      if (cActions) {
        if (op === 'set') {
          promises.push(this.setRelationshipOp(parentRef, childRef, parentPath));
        } else if (op === 'add') {
          promises.push(GlobalState.dispatch(cActions.add(childRef.id)));
        } else if (op === 'remove' && cActions.relationship.isOneToMany) {
          promises.push(GlobalState.dispatch(cActions.delete(childRef.id, null, null, {
            parentKey
          })));
        } else if (op === 'remove' && cActions.relationship.isOneToOne) {
          promises.push(GlobalState.dispatch(cActions.delete(null, null, {
            parentKey
          })));
        }
        after.push(() => GlobalState.dispatch(pActions.parent().list()));
      } else {
        const err = new Error('Parent Actions are not found for object');
        err.parentRef = parentRef;
        err.path = parentPath;
        err.childId = childRef.id;
        promises.push(Promise.reject(err));
      }
    }
  }
  createOrUpdateImages({
    promises
  }) {
    // to do? keep errors, then display at the end
    for (let i = 0; i < this.resourceImage.length; i++) {
      const item = this.resourceImage[i];
      const {
        objRef,
        value,
        op,
        path,
        imagePath,
        valueOverwrite
      } = item;
      const delegate = DataSources.getDelegate(objRef);
      const resourceDelegate = delegate?.resource(imagePath ?? `resourceImage/${path}`);
      if (op === 'set') {
        promises.push(GlobalState.dispatch(resourceDelegate.create(value[0], {
          type: value[0].type
        })).catch(err => {
          return GlobalState.dispatch(resourceDelegate.update([{
            path: 'type',
            value: value[0].type
          }], value[0]));
        }));
        promises.push(GlobalState.dispatch(delegate.update({
          data: {
            [path]: valueOverwrite ?? value[0].name
          }
        })));
      }
      if (op === 'remove') {
        promises.push(GlobalState.dispatch(resourceDelegate.delete()));
        promises.push(GlobalState.dispatch(delegate.update({
          data: {
            [path]: null
          }
        })));
      }
    }
  }
  run() {
    const promises = [];
    const after = [];
    const delegate = DataSources.getActions(this.objRef);
    // const close = LoadingView.showDialog( t( 'loading' ) )
    if (this.hasData) {
      this.createOrUpdateData({
        delegate,
        promises,
        after
      });
    }
    if (this.hasRelationship) {
      this.createOrUpdateRelationships({
        delegate,
        promises,
        after
      });
    }
    if (this.hasResourceImage) {
      this.createOrUpdateImages({
        delegate,
        promises,
        after
      });
    }
    if (promises.length === 0) {
      return Promise.resolve();
      // .then( () => {
      //   close()
      // } )
    }
    return Promise.all(promises).then(res => {
      P.all(after);
      return res;
      // .then( () => {
      //   close()
      // } )
    });
  }
}
class CreateTransaction extends Transaction {
  createOrUpdateData({
    delegate,
    promises
  }) {
    if (delegate) {
      const hookPlgs = Plugins.get('ItemCreateHook', m => {
        return Context.isMatch({
          objectType: delegate.relationship.objectType,
          path: delegate.relationship.path
        }, m);
      });
      let p;
      if (hookPlgs.length > 0) {
        p = GlobalState.dispatch(async (dispatch, getState) => {
          let data = this.data;
          for (let i = 0; i < hookPlgs.length; i++) {
            const plg = hookPlgs[i];
            // eslint-disable-next-line no-await-in-loop
            data = await plg.hook(data, this.context?.clientProps);
          }
          return dispatch(delegate.parent()?.create(data));
        });
        promises.push(p);
      } else {
        p = GlobalState.dispatch(delegate.parent?.()?.create(this.data));
        promises.push(p);
      }
      return p;
    }
    throw new Error('Actions are not found for object');
  }
  run() {
    const promises = [];
    const after = [];
    const delegate = DataSources.getActions(this.objRef);
    return this.createOrUpdateData({
      delegate,
      promises,
      after
    }).then(res => {
      this.objRef.id = res.id;
      if (this.hasRelationship) {
        this.createOrUpdateRelationships({
          promises,
          delegate,
          after
        });
      }
      if (this.hasResourceImage) {
        this.createOrUpdateImages({
          delegate,
          promises,
          after
        });
      }
      if (promises.length === 0) {
        return Promise.resolve();
      }
      return Promise.all(promises).then(res => {
        P.all(after);
        return res;
      });
    });
  }
  createOrUpdateImages(opts) {
    this.resourceImage = this.resourceImage.map(item => {
      const {
        objRef
      } = item;
      if (objRef.path === this.objRef.path && objRef.id == null) {
        return {
          ...item,
          objRef: this.objRef
        };
      }
      return item;
    });
    return super.createOrUpdateImages(opts);
  }
}
const createSet = (part, path, attribute) => {
  return (objRef, value, cxt, transaction) => {
    const runNow = transaction == null;
    if (transaction === true || transaction == null) {
      // eslint-disable-next-line no-param-reassign
      transaction = cxt?.isCreate === true ? new CreateTransaction(objRef, cxt) : new Transaction(objRef, cxt);
    }
    transaction.addPath(part, path, value);
    const externalId = attribute?.getTagStartingWith('externalId:', true);
    if (externalId) {
      const [networkKey, networkAlias] = externalId.split(':');
      transaction.addPath('header', `networkAliases/${networkKey}/${networkAlias}`, value);
      transaction.addPath('header', 'networkId', networkKey);
    }
    const isName = attribute?.hasTag('is:name');
    if (isName) {
      transaction.addPath('header', 'name', value);
    }
    return runNow ? transaction.run() : transaction;
  };
};

/**
 * Creates a set function for the given Blueprint Attribute
 */
const createAttrSet = attribute => {
  const adjustedPath = attribute.path.endsWith('*') ? attribute.path.slice(0, -1) : attribute.path;
  return createSet('data', adjustedPath, attribute);
};

/**
 * Creates a set function for the given Blueprint Attribute
 */
const createAttrCanSet = attribute => {
  return (objRef, value, cxt) => {
    if (attribute?.model?.source !== 'user') {
      return false;
    }
    const {
      usage
    } = cxt || {};
    if (usage != null) {
      if (attribute.hasTag(`${cxt?.isCreate ? 'create' : 'update'}:exclude:${usage}`)) {
        return false;
      }
    }
    const delegate = DataSources.getActions(objRef);
    if (delegate) {
      return cxt?.isCreate === true ? delegate.parent?.()?.canCreate() : delegate.canUpdate();
    }
    return false;
  };
};

/**
 * Creates a set function for the given Blueprint parent relationship Attribute
 */
const createParentAttrCanSet = attribute => {
  const attrCanSet = createAttrCanSet(attribute);
  return (objRef, value, cxt) => {
    const attrCan = attrCanSet(objRef, value, cxt);
    const parentRelationship = getParentRelationship(objRef, {
      blueprint: {
        attribute
      }
    });
    return !!(attrCan && parentRelationship);
  };
};

/**
 * Creates a set function for the given Blueprint Attribute
 */
const createParentAttrSet = attribute => {
  // Value is the parentRef
  return (childRef, value, cxt, transaction) => {
    const runNow = transaction == null;
    if (transaction === true || transaction == null) {
      // eslint-disable-next-line no-param-reassign
      transaction = cxt?.isCreate === true ? new CreateTransaction(childRef, cxt) : new Transaction(childRef, cxt);
    }
    const {
      parentRef,
      type,
      parentKey
    } = value;
    if (type === 'set') {
      transaction.setRelationship(parentRef, childRef, attribute.parentPath);
    } else if (type === 'add') {
      transaction.addRelationship(parentRef, childRef, attribute.parentPath);
    } else if (type === 'remove') {
      transaction.removeRelationship(parentRef, childRef, attribute.parentPath, parentKey);
    }
    return runNow ? transaction.run() : transaction;
  };
};
const createRelationshipAttrSet = attribute => {
  return (parentRef, value, cxt, transaction) => {
    const runNow = transaction == null;
    if (transaction === true || transaction == null) {
      // eslint-disable-next-line no-param-reassign
      transaction = cxt?.isCreate === true ? new CreateTransaction(parentRef, cxt) : new Transaction(parentRef, cxt);
    }
    const {
      childRef,
      type,
      parentKey
    } = value;
    if (type === 'set') {
      transaction.setRelationship(parentRef, childRef, attribute.path);
    } else if (type === 'add') {
      transaction.addRelationship(parentRef, childRef, attribute.path);
    } else if (type === 'remove') {
      transaction.removeRelationship(parentRef, childRef, attribute.path, parentKey);
    }
    return runNow ? transaction.run() : transaction;
  };
};

/**
 * Creates a set function for the given Blueprint Attribute
 */
const createHeaderSet = path => {
  return createSet('header', path);
};

/**
 * Creates a set function for a network id attribute
 */
const createNetworkIdSet = path => {
  const [, networkId] = path.split('/');
  const netIdSet = createHeaderSet(path);
  const headerSet = createHeaderSet('networkId');
  return (objRef, value, cxt, transaction) => {
    return netIdSet(objRef, value, cxt, headerSet(objRef, networkId, cxt, transaction));
  };
};
/**
 * Creates a set function for the given Blueprint Attribute
 */
const createHeaderCanSet = (attrName, blueprint) => {
  return (objRef, value, cxt) => {
    if (attrName === 'name') {
      if (!blueprint.hasTag('deviceName:editable')) {
        return false;
      }
    }
    const delegate = DataSources.getActions(objRef);
    if (delegate) {
      return cxt?.isCreate === true ? delegate.parent?.()?.canCreate() : delegate.canUpdate();
    }
    return false;
  };
};
const createResourceImageSet = attribute => {
  return (objRef, value, cxt, transaction, ...rest) => {
    const runNow = transaction == null;
    if (transaction === true || transaction == null) {
      // eslint-disable-next-line no-param-reassign
      transaction = cxt?.isCreate === true ? new CreateTransaction(objRef, cxt) : new Transaction(objRef, cxt);
    }
    const {
      type,
      value: val
    } = value;
    if (type === 'set') {
      transaction.setResourceImage(objRef, val, attribute.path);
    } else if (type === 'remove') {
      transaction.removeResourceImage(objRef, attribute.path);
    }
    return runNow ? transaction.run() : transaction;
  };
};
const createResourceImageListSet = attribute => {
  return (objRef, value, cxt, transaction, ...rest) => {
    const runNow = transaction == null;
    if (transaction === true || transaction == null) {
      // eslint-disable-next-line no-param-reassign
      transaction = cxt?.isCreate === true ? new CreateTransaction(objRef, cxt) : new Transaction(objRef, cxt);
    }
    const {
      additions,
      removals,
      imagePathRoot,
      value: attrValues
    } = value;
    const path = attribute?.path?.slice(0, -1);
    Object.keys(additions).forEach(add => {
      transaction.setResourceImage(objRef, [additions[add]], `${path}/${add}`, `${imagePathRoot}/${add}`, attrValues[add]);
    });
    removals.forEach(rem => {
      transaction.removeResourceImage(objRef, `${path}/${rem}`, `${imagePathRoot}/${rem}`);
    });
    return runNow ? transaction.run() : transaction;
  };
};

/**
 * Returns { relationship, match } for the parent relationship used to set
 * the attribute.
 */
function getParentRelationship(objRef, attr) {
  if (!objRef || !objRef.ref) {
    return null;
  }
  const {
    type,
    ref,
    id
  } = objRef;
  const lookupRef = ref.replace(`/${id}`, '');
  const lookupType = type;
  const delegate = DataSources.getDelegate({
    ...objRef,
    ref: lookupRef,
    type: lookupType
  }) || EMPTY;
  const {
    relationship,
    match
  } = delegate;

  // Given the obj's location in the relationship tree, look up the
  // location to find the possible parents
  if (relationship) {
    const srcs = attr?.blueprint?.attribute?.metadata?.setter?.parentSources;
    if (srcs) {
      const src = srcs.find(d => d.path === relationship.path);
      if (src && src.sourcePath) {
        const rel = Relationship.getByPath(src.sourcePath);
        if (rel) {
          return {
            relationship: rel.createResolved(match),
            match,
            filter: src.filter,
            queryName: `parentRel-${src.sourcePath}`,
            objectType: rel.options.objectType
          };
        }
      }
    }
  }
  return null;
}
export default {
  Transaction,
  createAttrSet,
  createAttrCanSet,
  createParentAttrSet,
  createParentAttrCanSet,
  createRelationshipAttrSet,
  createRelationshipAttrCanSet: createParentAttrCanSet,
  createHeaderSet,
  createHeaderCanSet,
  createResourceImageSet,
  createResourceImageListSet,
  createResourceImageCanSet: createAttrCanSet,
  createResourceImageListCanSet: createAttrCanSet,
  createNetworkIdSet
};